import React, { useState, useEffect, useRef, useCallback } from 'react';
import { postAPI, postAPIForm } from '../../../app/api';
import { setStore, store } from '../../../app/store';
import Header from '../../Universal/Header';
import Swal from 'sweetalert2';
import Footer from '../../Universal/Footer';
import Razorpay from '../../../GlobalComponent/Razorpay';
// import rulesImage from '../../../assets/img/rules_regulations.jpg';
import profileImg from "../../../assets/img/intersect.png"
import registerBanner from "../../../assets/img/Header.jpg"
// Define file type icons
const fileIcons = {
    pdf: '/icons/pdf-icon.png',
    docx: '/icons/docx-icon.png',
    doc: '/icons/docx-icon.png',
    xlsx: '/icons/excel-icon.png',
    xls: '/icons/excel-icon.png',
    txt: '/icons/txt-icon.png',
    default: '/icons/file-icon.png', // Default icon for unknown types
};


const { REACT_APP_BRANDURL } = process.env;

export default function Registration() {

    const [form_data, setFormData] = useState({
        first_name: '',
        middle_name: '',
        last_name: '',
        designation: '',
        dob_of_spouse: '',
        email_id: '',
        mobile_number: '',
        landline_number: '',
        passing_year: '',
        discipline: '',
        blood_group: '',
        postal_address: '',
        pin_code: '',
        state: '',
        country: '',
        spouse_name: '',
        date_of_birth: '',
        introduce_by: '',
        introduce_passing_year: '',
        introduce_discipline: '',
        image: '',
        is_agree: false,
        action: 'ADD'
    });

    const [TempRazorpayPayload, setTempRazorpayPayload] = useState({});
    const [IsMemberAdded, setIsMemberAdded] = useState(1);
    const [MemberShipFee, setMemberShipFee] = useState(0);
    const [UserCode, setUserCode] = useState('');
    const [Loading, setLoading] = useState(false);
    const store_data = JSON.parse(store());
    const fileInputRef = useRef(null);

    const fieldsToValidate = [{
        name: 'image', label: 'Profile Photo', type: 'file', required: true, allowedTypes: ['jpg', 'jpeg', 'png']
    }, {
        name: 'first_name', label: 'First Name', type: 'text', required: true, minimumLength: 2, maximumLength: 50,
    }, {
        name: 'middle_name', label: 'Middle Name', type: 'text', required: false, minimumLength: 0, maximumLength: 50,
    }, {
        name: 'last_name', label: 'Last Name', type: 'text', required: true, minimumLength: 2, maximumLength: 50,
    }, {
        name: 'designation', label: 'Designation', type: 'text', required: false, minimumLength: 2, maximumLength: 100,
    }, {
        name: 'discipline', label: 'Discipline', type: 'text', required: true, minimumLength: 2, maximumLength: 100,
    }, {
        name: 'blood_group', label: 'Blood Group', type: 'text', required: true, minimumLength: 1, maximumLength: 10,
    }, {
        name: 'postal_address', label: 'Postal Address', type: 'text', required: false, minimumLength: 5, maximumLength: 200,
    }, {
        name: 'passing_year', label: 'Passing Year', type: 'text', required: true, minimumLength: 4, maximumLength: 4,
    }, {
        name: 'date_of_birth', label: 'Date of Birth', type: 'date', required: true,
    }, {
        name: 'state', label: 'State', type: 'text', required: false, minimumLength: 2, maximumLength: 100,
    }, {
        name: 'country', label: 'Country', type: 'text', required: false, minimumLength: 2, maximumLength: 100,
    }, {
        name: 'pin_code', label: 'Pin Code', type: 'text', required: false, minimumLength: 5, maximumLength: 10,
    }, {
        name: 'email_id', label: 'Email ID', type: 'email', required: true, minimumLength: 5, maximumLength: 100,
    }, {
        name: 'mobile_number', label: 'Mobile Number', type: 'text', required: true, minimumLength: 10, maximumLength: 10,
    }, {
        name: 'spouse_name', label: 'Spouse Name', type: 'text', required: false, minimumLength: 0, maximumLength: 100,
    }, {
        name: 'dob_of_spouse', label: 'Date of Birth of Spouse', type: 'date', required: false,
    }, {
        name: 'introduce_by', label: 'Introduced By', type: 'text', required: true, minimumLength: 2, maximumLength: 100,
    }, {
        name: 'introduce_passing_year', label: 'Introduced Passing Year', type: 'text', required: true, minimumLength: 4, maximumLength: 4,
    }, {
        name: 'introduce_discipline', label: 'Introduced Discipline', type: 'text', required: true, minimumLength: 2, maximumLength: 100,
    }, {
        name: 'is_agree', label: 'Agree to Terms', type: 'checkbox', required: true,
    }]

    const ValidationHandler = (payload) => {
        for (let field of fieldsToValidate) {
            const value = payload[field.name];
            if (field.required) {
                if (field.type === 'checkbox') {
                    if (!value) {
                        return { status: false, msg: `Please accept ${field.label}` };
                    }
                } else if (!value || value.toString().trim() === '') {
                    return { status: false, msg: `${field.label} is required` };
                } else if (field.type === 'text' || field.type === 'email' || field.type === 'number') {
                    if (value.length < field.minimumLength) {
                        return { status: false, msg: `${field.label} must be at least ${field.minimumLength} characters long` };
                    }
                    if (value.length > field.maximumLength) {
                        return { status: false, msg: `${field.label} must be at most ${field.maximumLength} characters long` };
                    }
                } else if (field.type === 'file') {
                    if (value) {
                        const fileExtension = value.split('.').pop().toLowerCase();
                        if (!field.allowedTypes.includes(fileExtension)) {
                            return { status: false, msg: `${field.label} must be one of the following types: ${field.allowedTypes.join(', ')}` };
                        }
                    }
                }
            } else {
                if (!value || value.toString().trim() === '') {
                    continue; // Skip further validation for non-required empty fields
                }
            }
        }
        return { status: true, msg: 'Validation passed' };
    }


    const generateUniqueId = (prefix, user_code) => {
        let ISO = new Date().toISOString().split('T')[0]
        let serial_no = Math.floor(1000 + Math.random() * 9000); // 4 digit random number
        let timestamp = ISO.split('-')
        let date = timestamp[2]
        let month = parseInt(timestamp[1])
        let year = timestamp[0].slice(2)
        // Combine prefix, timestamp, and random number to create the unique ID
        const userId = `${prefix}${user_code}${date}${String.fromCharCode(64 + month)}${serial_no}${year}`;

        return userId;
    }


    const handleButtonClick = () => {
        fileInputRef.current.click();   // Open hidden file dialog
    };

    // Calculate membership fee based on age
    const calculateMembershipFee = useCallback(() => {
        if (!form_data.date_of_birth) return 0;

        const birthDate = new Date(form_data.date_of_birth);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();

        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        if (age > 60) {
            setMemberShipFee(8500);
            return 8500;
        } else {
            setMemberShipFee(10500);
            return 10500;
        }
    }, [form_data.date_of_birth]);

    useEffect(() => {
        calculateMembershipFee();
    }, [calculateMembershipFee]);

    const handleFileChange = async (e) => {
        // console.log(e.target.files[0])
        const file = e.target.files[0];
        if (file) {
            const formData = new FormData();
            formData.append('baseDir', 'Registration');
            formData.append('filename', 'file');
            formData.append('original_file', file);
            const data = await postAPIForm('file/uploadFile', formData);
            if (data.status === 0) {
                // setError({ status: 0, msg: 'Image Not Uploaded' });
                Swal.fire({
                    title: "Sorry!",
                    text: 'Image Not Uploaded. Please try again.',
                    icon: "error"
                });
                return;
            } else {
                setFormData({ ...form_data, [e.target.name]: data.filepath })
            }
        }
    };


    useEffect(() => {
        setIsMemberAdded(store_data?.is_member_added || 1)
        setUserCode(store_data?.user_code || '')
    }, [store_data?.user_code, store_data?.is_member_added])

    const handleChange = e => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...form_data,
            [name]: type === 'checkbox' ? checked : value
        });
    }

    const handleSubmit = async (e) => {
        e?.preventDefault();
        setLoading(true);
        try {
            const validationStatus = ValidationHandler(form_data);

            if (!validationStatus?.status) {
                Swal.fire({
                    title: "Sorry!",
                    text: validationStatus?.msg || "Validation failed. Please check your inputs.",
                    icon: "error"
                });
                setLoading(false);
                return;
            }

            // Validate required fields
            if (!form_data.first_name || !form_data.last_name || !form_data.email_id || !form_data.mobile_number) {
                Swal.fire({
                    title: "Sorry!",
                    text: "Please fill all required fields",
                    icon: "error"
                });
                setLoading(false);
                return;
            }

            if (!form_data.is_agree) {
                Swal.fire({
                    title: "Sorry!",
                    text: "Please accept terms & conditions",
                    icon: "error"
                });
                setLoading(false);
                return;
            }

            // Validate minimum age requirement
            if (form_data.date_of_birth) {
                const birthDate = new Date(form_data.date_of_birth);
                const today = new Date();
                let age = today.getFullYear() - birthDate.getFullYear();
                const monthDiff = today.getMonth() - birthDate.getMonth();

                if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
                    age--;
                }

                if (age < 22) {
                    Swal.fire({
                        title: "Sorry!",
                        text: "You must be at least 22 years old to apply for membership",
                        icon: "error"
                    });
                    setLoading(false);
                    return;
                }
            }

            // Add registration date fields
            const now = new Date();
            const registration_month = now.toLocaleString('default', { month: 'long' });
            const registration_date = now.getDate();
            const registration_year = now.getFullYear();
            const registrationData = {
                ...form_data,
                registration_month,
                registration_date,
                registration_year
            };
            const response = await postAPI(`authentication/users/add-member`, IsMemberAdded ? registrationData : { ...registrationData, action: "UPDATE", user_code: UserCode });
            console.log(response);

            if (response?.status === 1) {
                if (response?.is_member_added === 1) {
                    setIsMemberAdded(1);
                    const paymentPayload = {
                        user_code: response?.data?.user_code,
                        invoice_no: generateUniqueId('I', response?.data?.user_code),
                        name: `${form_data.first_name} ${form_data.last_name}`,
                        email: form_data.email_id,
                        phone: form_data.mobile_number,
                        user_id: response?.data?.user_code,
                        amount: MemberShipFee,
                        purpose: 'Membership Fee'
                    };
                    setTempRazorpayPayload(paymentPayload);
                    setStore({ user_code: response?.data?.user_code, is_member_added: response?.is_member_added });
                    setUserCode(response?.data?.user_code);
                    setTimeout(async () => {
                        await initiatePayment(paymentPayload);
                    }, 2000);
                } else {
                    setIsMemberAdded(0);
                    setUserCode(response?.data?.user_code);
                }
                // Reset form
                setFormData({
                    first_name: '',
                    middle_name: '',
                    last_name: '',
                    designation: 'Member',
                    dob_of_spouse: '',
                    email_id: '',
                    mobile_number: '',
                    landline_number: '',
                    passing_year: '',
                    discipline: '',
                    blood_group: '',
                    postal_address: '',
                    pin_code: '',
                    state: '',
                    country: '',
                    spouse_name: '',
                    date_of_birth: '',
                    introduce_by: '',
                    introduce_passing_year: '',
                    introduce_discipline: '',
                    image: '',
                    is_agree: false,
                    action: 'ADD'
                });
                setLoading(false);
                Swal.fire({
                    title: "Good job!",
                    text: response?.msg || "Message sent successfully!",
                    icon: "success"
                });
            } else {
                Swal.fire({
                    title: "Sorry!",
                    text: response?.msg || "Registration failed",
                    icon: "error"
                });
                setLoading(false);
            }
        } catch (e) {
            console.log(e);
            Swal.fire({
                title: "Sorry!",
                text: e.message || "An error occurred",
                icon: "error"
            });
            setLoading(false);
        }
    }





    // Load Razorpay script
    const loadRazorpayScript = () => {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = "https://checkout.razorpay.com/v1/checkout.js";
            script.onload = () => resolve(true);
            script.onerror = () => resolve(false);
            document.body.appendChild(script);
        });
    };

    const handleTransaction = async (options, is_edit = 0, payload = null) => {
        try {
            const activePayload = payload || TempRazorpayPayload;
            const filter = {
                ...options,
                user_code: activePayload?.user_code,
                invoice_no: activePayload?.invoice_no,
                payment_mode: 'ONLINE - RAZORPAY',
                submission_status: is_edit ? 'PAID' : 'PENDING',
                user: JSON.stringify({
                    name: activePayload?.name,
                    email: activePayload?.email,
                    phone: activePayload?.phone
                }),
            };
            setStore({ is_member_added: 0 });

            const response = await postAPI("finance/create", filter);
            console.log("Transaction response:", response);

            if (response?.status === 1) {
                if (is_edit === 0) {
                    // Only open Razorpay on initial transaction creation
                    await openRazorpay(options?.orderData, payload || TempRazorpayPayload);
                } else {
                    // Payment update successful
                    Swal.fire({
                        icon: 'success',
                        title: 'Payment Successful',
                        text: 'Your payment has been processed successfully.',
                    });
                }
                return response;
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Transaction Failed',
                    text: response?.msg || "Transaction processing failed. Please try again.",
                });
                return response;
            }
        } catch (error) {
            console.error("Error processing transaction:", error);
            if (is_edit === 0) {
                // Only show error alert on initial transaction
                alert("An error occurred while processing payment. Please try again.");
            }
            throw error;
        }
    };

    const openRazorpay = async (orderData, payload) => {
        const activePayload = payload || TempRazorpayPayload;
        const options = {
            key: process.env.REACT_APP_RAZORPAY_KEY_ID || "rzp_test_BRhK2PmZqc0kKi",
            amount: orderData.amount,
            currency: orderData.currency,
            name: 'BE College ExStudents\' Club',
            email: 'info@b.e.collegeexstudentclub.com',
            contact: '+033 2321 2261',
            description: JSON.stringify({
                module: 'MEMBERSHIP',
                invoice_id: activePayload?.invoice_no,
                user_code: activePayload?.user_code,
            }),
            order_id: orderData.id,
            handler: async (response) => {
                console.log("Payment successful Razorpay Response:", response);
                try {
                    const transactionResponse = await handleTransaction({
                        module: 'MEMBERSHIP',
                        amount: MemberShipFee,
                        razorpay_order_id: response.razorpay_order_id,
                        razorpay_payment_id: response.razorpay_payment_id,
                        razorpay_signature: response.razorpay_signature,
                    }, 1, activePayload);
                    // setIsMembershipPayment(0);
                    console.log("Updated successful payment transaction:", transactionResponse);
                    setLoading(false);
                } catch (error) {
                    console.error("Error updating payment status:", error);
                    Swal.fire({
                        icon: 'warning',
                        title: 'Payment Received',
                        text: 'Payment was successful but there was an issue updating the status. Please contact support.',
                    });
                    setLoading(false);
                }
            },
            prefill: {
                name: activePayload?.name,
                email: activePayload?.email,
                contact: activePayload?.phone,
            },
            theme: { color: "#012035" },
            modal: {
                ondismiss: () => {
                    console.log("Payment modal closed by user");
                    setLoading(false);
                },
            },
        };

        const razorpayInstance = new window.Razorpay(options);

        razorpayInstance.on("payment.failed", async (response) => {
            console.error("Payment failed:", response.error);

            // Update payment status to failed in backend
            try {
                const transactionResponse = await handleTransaction({
                    module: 'MEMBERSHIP',
                    amount: MemberShipFee,
                    razorpay_order_id: orderData.id,
                    razorpay_payment_id: response.error.metadata?.payment_id || '',
                    razorpay_signature: '',
                    submission_status: 'FAILED',
                    error_description: response.error.description,
                    error_code: response.error.code
                }, 1, activePayload);
                console.log("Updated failed payment transaction:", transactionResponse);
            } catch (error) {
                console.error("Error updating failed payment:", error);
            }

            alert(`Payment failed: ${response.error.description}`);
            setLoading(false);
        });

        razorpayInstance.open();
    };

    const initiatePayment = async (payload = null) => {
        try {
            setLoading(true);
            const activePayload = payload || TempRazorpayPayload;

            // Validate payment amount
            if (!MemberShipFee || MemberShipFee <= 0) {
                alert("Invalid payment amount");
                setLoading(false);
                return;
            }

            // Validate required Value data
            if (!activePayload?.invoice_no || !activePayload?.user_code) {
                alert("Missing required payment information");
                setLoading(false);
                return;
            }

            const scriptLoaded = await loadRazorpayScript();
            if (!scriptLoaded) {
                alert("Failed to load Razorpay SDK. Please check your internet connection and try again.");
                setLoading(false);
                return;
            }

            // Generate order via API
            const response = await postAPI('api/payment/order', {
                amount: MemberShipFee,
                currency: "INR",
                receipt: `fee_${activePayload?.invoice_no}_${Date.now()}`
            });
            // console.log("Order creation response:", response);

            // if (!response.ok) {
            //   const errorText = await response.text();
            //   console.error("Order creation failed:", errorText);
            //   throw new Error(`HTTP error! status: ${response.status}`);
            // }

            const orderData = response;
            console.log("Order created:", orderData);

            if (!orderData?.id) {
                throw new Error("Invalid order response from server");
            }

            await handleTransaction({
                module: 'MEMBERSHIP',
                amount: MemberShipFee,
                razorpay_order_id: orderData?.id,
                razorpay_payment_id: '',
                razorpay_signature: '',
                orderData: orderData
            }, 0, activePayload);
        } catch (error) {
            console.error("Error initiating payment:", error);
            alert("Failed to initiate payment. Please try again.");
            setLoading(false);
        }
    };

    const handleRulesClick = () => {
        const rulesContent = `
            <div class="text-start" style="max-height: 70vh; overflow-y: auto; text-align: left;">
                <h4 class="text-center mb-3">Enrolment Application Form</h4>
                <h5 class="text-center mb-4">B E College Ex-Students' Club</h5>
                <p><strong>Possible modes of paying :</strong></p>
                <p>Subscription may be sent by way of any of the following options, along with the filled-in Enrolment Application Form.</p>
                <p><strong>A.</strong> Those who want to pay by cash (for Annual Members only) may hand it over to the Treasurer in the Club premises, personally or through a friend or by a messenger. Office hours are 6:30 PM to 8:30 PM (weekdays).</p>
                <p>Life Membership fee : ₹ 8,000 for age above 60 and ₹ 10,000 for age 60 or below, at joining. Please allow 10 days for processing, after fees are credited. Annual Membership fee is valid from 24th January to 23rd January of the next year, irrespective of the date of payment. These rates are valid until further notice.</p>
                
                <p><strong>B.</strong> In case of cheque, please ensure it is compliant with CTS 2010 (with IFS & bank branch code). For safety, please cross your cheque / DD 'A/c payee only'. Please issue cheque / DD in the name of <strong>B E COLLEGE EX-STUDENTS CLUB</strong> and make it payable at Kolkata, India. Those who want to send cheque or DD by post / courier service may send it addressed <u>only</u> to <strong>Treasurer</strong>, at the above address. If you send the cheque & application form by ordinary post or courier, please send an email / postcard informing the <strong>Treasurer</strong> the details of the cheque / DD, along with your full name. Acceptance of Enrolment Application Form is subject to encashment of cheque / DD.</p>
                <p class="small fst-italic">[Note : Date format varies from country to country. So, in your cheque / DD please spell out the month in words, instead of numerals, e.g. 17 September 2013 or September 17, 2013. This is particularly important for overseas friends, who are habituated to date formats as in USA or Sweden, which confuse the bank bureaucracy, causing cheques to be dishonored]</p>
                
                <p><strong>C.</strong> Those who want to pay through ATM or by bank transfer / NEFT / RTGS may pay directly to <strong>B E COLLEGE EX-STUDENTS CLUB</strong> account. The bank details are as follows. After payment, please inform the <strong>Treasurer</strong> by email (email id in letterhead), giving the reference details of payment and your full name, so that he can match up with the next updated bank passbook.</p>
                
                <div class="table-responsive">
                    <table class="table table-bordered table-sm">
                        <tbody>
                            <tr>
                                <td><strong>Bank :</strong></td>
                                <td>Central Bank of India, Salt Lake City Branch (03492)<br>DL 7A, Salt Lake City, Sector II<br>Kolkata 700 091, West Bengal, India</td>
                            </tr>
                            <tr>
                                <td><strong>A/c No. :</strong></td>
                                <td>3379739426</td>
                            </tr>
                             <tr>
                                <td><strong>IFS Code :</strong></td>
                                <td>CBIN0283492</td>
                            </tr>
                             <tr>
                                <td><strong>MICR Code :</strong></td>
                                <td>7000016081</td>
                            </tr>
                             <tr>
                                <td><strong>Branch Code :</strong></td>
                                <td>03492</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <p><strong>Library Membership :</strong></p>
                <p>The Club maintains a small but well stocked library. Option of Library Membership is available to all Club Members and spouses for a small fee each. To avail of the library facility, please contact the Librarian, who will inform you the Library Membership fee, which is to be paid separately, directly to the Librarian, over and above the Club Membership fee.</p>
                
                <hr>
                <p class="small fst-italic">The Club Executive Committee reserves the right to accept or reject any application without stating any reason. Also see overleaf. When printing, please print these 2 pages on both sides of same A4 sheet.</p>
            </div>
        `;

        Swal.fire({
            html: rulesContent,
            showCloseButton: true,
            showConfirmButton: false,
            width: '800px',
            padding: '20px',
        });
    };

    const getMaxDOB = () => {
        const today = new Date();
        today.setFullYear(today.getFullYear() - 22);
        return today.toISOString().split('T')[0]; // yyyy-mm-dd
    };
    return (
        <>
            <Header />
            <section className="hero-section member-banner">
                <div className="banner-image">
                    <img src={registerBanner} className="img-fluid" alt="Membership Banner" />
                </div>
                <div className="hero-content">
                    <h1 className="fw-bold">New <span>Membership Form</span></h1>
                    {/* <p className="mt-3">Membership opens the door to a vibrant network of alumni, meaningful interactions, and
                        exciting club activities. Whether it's events, gatherings, or community programs, members enjoy a shared
                        space where friendships grow and memories are made.</p> */}
                </div>
            </section>
            <section className="member">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 sidebar">
                            <div className="upload-photo">
                                <img src={form_data?.image || profileImg} width="100" alt="Profile" />
                            </div>
                            <input
                                type="file"
                                ref={fileInputRef}
                                name='image'
                                style={{ display: "none" }}
                                onChange={handleFileChange}
                            />
                            <button type="button" className="upload-btn" onClick={handleButtonClick}>Upload photo</button>
                            <hr className="my-4" style={{ borderColor: "rgba(255,255,255,0.3)" }} />
                            <h5>Membership Fee : 500</h5>
                            <h5>Life Membership<br /> Fee:</h5>
                            <p><strong>₹ 8,000</strong> for age above 60 and <strong>₹ 10,000</strong> for age 60 & below.</p>
                            <div className="fee-box"><span>₹</span> {MemberShipFee === 8500 ? '8,500' : MemberShipFee === 10500 ? '10,500' : MemberShipFee}</div>
                            <div className='sidebar-button'>
                                {Loading ?
                                    <button type="button" className="submit-btn d-lg-block d-none">SUBMIT DETAILS ... </button>
                                    :
                                    <>
                                        {
                                            <Razorpay handleSubmit={handleSubmit} Loading={Loading} module={'MEMBERSHIP'} Amount={MemberShipFee} Value={TempRazorpayPayload} />
                                        }
                                    </>
                                }

                            </div>
                        </div>
                        <div className="col-lg-9 form-section">
                            <form onSubmit={handleSubmit}>
                                <div className="row align-items-stretch">
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>First Name: <span className="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter first name"
                                                name="first_name"
                                                value={form_data.first_name}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Middle Name:</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter middle name"
                                                name="middle_name"
                                                value={form_data.middle_name}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Family Name / Surname: <span className="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter surname"
                                                name="last_name"
                                                value={form_data.last_name}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                    {/* <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Designation:</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter designation"
                                                name="designation"
                                                value={form_data.designation}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div> */}
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label>Discipline: <span className="text-danger">*</span> <span className="text-primary">(Architecture, Civil, Electrical, Mechanical, Metallurgy, Mining, etc)</span></label>
                                            <select
                                                className="form-control"
                                                name="discipline"
                                                value={form_data.discipline}
                                                onChange={handleChange}
                                                required
                                            >
                                                <option value="">Select discipline</option>
                                                <option value="Architecture">Architecture</option>
                                                <option value="Civil">Civil</option>
                                                <option value="Electrical">Electrical</option>
                                                <option value="Mechanical">Mechanical</option>
                                                <option value="Metallurgy">Metallurgy</option>
                                                <option value="Mining">Mining</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label>Blood Group: <span className="text-danger">*</span></label>
                                            <select
                                                className="form-control"
                                                name="blood_group"
                                                value={form_data.blood_group}
                                                onChange={handleChange}
                                                required
                                            >
                                                <option value="">Select blood group</option>
                                                <option value="O+">O+</option>
                                                <option value="O-">O-</option>
                                                <option value="A+">A+</option>
                                                <option value="A-">A-</option>
                                                <option value="B+">B+</option>
                                                <option value="B-">B-</option>
                                                <option value="AB+">AB+</option>
                                                <option value="AB-">AB-</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-8">
                                        <div className="form-group">
                                            <label>
                                                Postal Address:
                                                <span className="text-primary">(Includes flat no, floor no, house no, street, area, village,
                                                    district etc)</span>
                                            </label>
                                            <textarea
                                                className="form-control"
                                                placeholder="Enter postal address"
                                                name="postal_address"
                                                value={form_data.postal_address}
                                                onChange={handleChange}
                                            ></textarea>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Year of Passing: <span className="text-danger">*</span></label>
                                            {/* <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter year of passing"
                                                name="passing_year"
                                                value={form_data.passing_year}
                                                onChange={handleChange}
                                            /> */}
                                            <select
                                                className="form-control"
                                                name="passing_year"
                                                value={form_data.passing_year}
                                                onChange={handleChange}
                                            >
                                                <option value="">Select year of passing</option>
                                                {Array.from({ length: 100 }, (_, i) => new Date().getFullYear() - i).map(year => (
                                                    <option key={year} value={year}>{year}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Date of Birth: <span className="text-danger">*</span></label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                name="date_of_birth"
                                                value={form_data.date_of_birth}
                                                onChange={handleChange}
                                                max={getMaxDOB()}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className='col-lg-12'>
                                        <div className="row align-items-stretch">
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>State:</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter state"
                                                        name="state"
                                                        value={form_data.state}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Country:</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter country"
                                                        name="country"
                                                        value={form_data.country}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Pin Code:</label>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        placeholder="Enter pin code"
                                                        name="pin_code"
                                                        value={form_data.pin_code}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row align-items-stretch">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Email ID: <span className="text-danger">*</span></label>
                                                    <input
                                                        type="email"
                                                        className="form-control"
                                                        placeholder="Enter Email ID"
                                                        name="email_id"
                                                        value={form_data.email_id}
                                                        onChange={handleChange}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Alternative Email Id:</label>
                                                    <input
                                                        type="email"
                                                        className="form-control"
                                                        placeholder="Enter alternative email"
                                                        name="alternative_email_id"
                                                        value={form_data.alternative_email_id}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Mobile Number: <span className="text-danger">*</span></label>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        placeholder="Enter mobile number"
                                                        name="mobile_number"
                                                        value={form_data.mobile_number}
                                                        onChange={handleChange}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Landline No:</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter landline number"
                                                        name="landline_number"
                                                        value={form_data.landline_number}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Name of Spouse:</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter spouse name"
                                                        name="spouse_name"
                                                        value={form_data.spouse_name}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                            {/* <div className="form-group">
                                                <label>Spouse Date of Birth:</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    name="dob_of_spouse"
                                                    value={form_data.dob_of_spouse}
                                                    onChange={handleChange}
                                                />
                                            </div> */}
                                            <div className='col-lg-12'>
                                                <div className='row d-flex flex-wrap bg-white'>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label>Introduced by: <span className="text-danger">*</span></label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Enter introducer name"
                                                                name="introduce_by"
                                                                value={form_data.introduce_by}
                                                                onChange={handleChange}
                                                                required
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label>Year of passing: <span className="text-danger">*</span></label>
                                                            {/* <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Enter introducer year of passing"
                                                                name="introduce_passing_year"
                                                                value={form_data.introduce_passing_year}
                                                                onChange={handleChange}
                                                            /> */}
                                                            <select
                                                                className="form-control"
                                                                name="introduce_passing_year"
                                                                value={form_data.introduce_passing_year}
                                                                onChange={handleChange}
                                                                required
                                                            >
                                                                <option value="">Select year of passing</option>
                                                                {Array.from({ length: 100 }, (_, i) => new Date().getFullYear() - i).map(year => (
                                                                    <option key={year} value={year}>{year}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label>Discipline: <span className="text-danger">*</span></label>
                                                            <select
                                                                className="form-control"
                                                                name="introduce_discipline"
                                                                value={form_data.introduce_discipline}
                                                                onChange={handleChange}
                                                                required
                                                            >
                                                                <option value="">Select discipline</option>
                                                                <option value="Architecture">Architecture</option>
                                                                <option value="Civil">Civil</option>
                                                                <option value="Electrical">Electrical</option>
                                                                <option value="Mechanical">Mechanical</option>
                                                                <option value="Metallurgy">Metallurgy</option>
                                                                <option value="Mining">Mining</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 mt-3">
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                name="is_agree"
                                                id="agreeCheck"
                                                checked={form_data.is_agree}
                                                onChange={handleChange}
                                            />
                                            <label className="form-check-label" htmlFor="agreeCheck">
                                                I agree to abide by all club rules & discretionary decisions of the club Executive Committee. The Club Executive Committee reserves the right to accept or reject any application without stating any reason.
                                            </label>
                                        </div>
                                    </div>
                                    {/* <button class="submit-btn d-lg-none d-block" onClick={handleSubmit}>SUBMIT DETAILS</button> */}
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    )
}
